var $ = require('jquery');
var LAST_TAXO_ID = -1;
// $(window).on('site:initPage', function(evt, el){
$(window).on('sksmoothanim:nextPageFadeStart', function(evt, el){
	if ($(el).find('.projets__liste__items').length === 0) {
		// LAST_TAXO_ID = -1; // reset or not ?
		return;
	}
	if (LAST_TAXO_ID == -1) {
		LAST_TAXO_ID = $('.projets__taxo__item').eq(0).attr('data-id');
	}
	$('.projets__taxo__item').on('click', function(){
		ShowTaxoGrid($(this).attr('data-id'), /* hide previous */ true);
	});
	setTimeout(function() {
		ShowTaxoGrid(LAST_TAXO_ID, /* hide previous */ false);
	}, 500);
	var hasMouse = window.matchMedia('(pointer: fine)').matches;
	var canMouseOut = true;
	// hasMouse = false;
	setTimeout(function() {
		if ( hasMouse ) {
			$(el).find('.projetliste__infos__group__visuel').hover(function(){
				$(this).addClass('is-active');
				$('[data-id-projethover="'+$(this).attr('data-id')+'"]').addClass('is-active');
			}, function(){
				if ( canMouseOut ) {
					$(this).removeClass('is-active');
					$('[data-id-projethover="'+$(this).attr('data-id')+'"]').removeClass('is-active');
				}
			});
			$(el).find('.projetliste__infos__group__visuel').click(function(){
				canMouseOut = false;
				$(this).addClass('is-active');
				$('[data-id-projethover="'+$(this).attr('data-id')+'"]').addClass('is-active');
			});
		}
		else {
			$(el).find('.projetliste__infos__group__visuel').click(function(){
				$zoomEls = $('[data-id-projethover="'+$(this).attr('data-id')+'"]');
				var $zoomParentInner = $('<div class="projetliste__hover__transition__inner"></div>').append($zoomEls.clone());
				var $zoomParent = $('<div class="projetliste__hover__transition"></div>').append($zoomParentInner);
				$zoomParent.appendTo($('.site')).addClass('is-active');
				setTimeout(function() {
					$zoomParentInner.find('>div').addClass('is-active');
				}, 10);
			});
		}
	}, 1100);
	if ( hasMouse ) {
		HandleMouseMove(el);
	}
});

var ShowTaxoGrid = function(taxoId, hidePrevious) {
	console.log('hidePrevious', hidePrevious);
	LAST_TAXO_ID = taxoId;
	var delay = 0;
	if ( hidePrevious ) {
		gsap.to($('.projets__liste__items.is-active'), {opacity:0, ease:'none', duration:0.15});
		delay = 0.15;
	}
	console.log('delay', delay);
	var $nextEl = $('.projets__liste__items').filter('[data-taxo-id="'+taxoId+'"]');
	var tl = gsap.timeline({paused : true});
	tl.set($nextEl, {opacity:1});
	tl.from($nextEl.find('.projets__liste__item').shuffle(), {
		scale: 0.85,
		opacity: 0,
		duration: 1.3,
		ease: 'power2.out',
		stagger: 0.04,
		force3D: true,        // Force l'accélération matérielle (GPU)
	    // clearProps: "scale",
	});
	setTimeout(function() {
		$('.projets__liste__items.is-active').removeClass('is-active');
		$('html, body').scrollTop(0);
		$nextEl.addClass('is-active');
		$('.projets__taxo__item').removeClass('is-active')
			.filter('[data-id="'+taxoId+'"]').addClass('is-active');
		tl.play();
	}, delay * 1000);
};

var HandleMouseMove = function(el){
	$(el).find('.projetliste__infos__group__visuel').each(function() {
	    var $thumb = $(this);
	    var $grandVisuel = $('[data-id-projethover="'+$(this).attr('data-id')+'"] .projetliste__hover__infos__group__visuel');
	    
	    // Initialisation de GSAP
	    var xTo = gsap.quickTo($grandVisuel, "x", { duration: 2, ease: "power2.out" });
	    var yTo = gsap.quickTo($grandVisuel, "y", { duration: 2, ease: "power2.out" });

	    // On prépare toutes les variables de stockage en dehors
	    var thumbOffset, thumbWidth, thumbHeight;
	    var maxMoveX, maxMoveY;

	    function getTargetPositions(e) {
	        var ratioX = Math.min(Math.max((e.pageX - thumbOffset.left) / thumbWidth, 0), 1);
	        var ratioY = Math.min(Math.max((e.pageY - thumbOffset.top) / thumbHeight, 0), 1);
	        
	        return {
	            x: ratioX * maxMoveX,
	            y: ratioY * maxMoveY
	        };
	    }

	    // On calcule TOUT une seule fois quand la souris entre
	    $thumb.on('mouseenter', function(e) {
	        // 1. Dimensions du thumbnail
	        thumbOffset = $thumb.offset();
	        thumbWidth = $thumb.get(0).getBoundingClientRect().width;
	        thumbHeight = $thumb.get(0).getBoundingClientRect().height;

	        // 2. Calcul du débattement max (le "surplus" par rapport à l'écran)
	        maxMoveX = window.innerWidth - $grandVisuel.outerWidth();
	        maxMoveY = window.innerHeight - $grandVisuel.outerHeight();

	        var pos = getTargetPositions(e);

	        gsap.set($grandVisuel, { x: pos.x, y: pos.y });

	        xTo(pos.x);
	        yTo(pos.y);
	    });

	    // Le mousemove est maintenant une vraie plume
	    $thumb.on('mousemove', function(e) {
	    	
	        if (!thumbOffset) return;

	        var pos = getTargetPositions(e);
	        xTo(pos.x);
	        yTo(pos.y);
	    });
	});
};